import _ from 'underscore';
import { FilterStorageType, removeQueryByColumnId } from '@bingads-webui/filter-commons';
import { appendPeriodOverPeriodProperties } from '@bingads-webui-campaign/common-grid-config';
import { isValidForFeature } from '@bingads-webui/custom-columns-shared-config';

let filterService;
let safeGetString;
let permissions;

export function initialize(config) {
  ({ filterService, safeGetString, permissions } = config);
}

export const customColumnOperations = {
  add: 'add',
  edit: 'edit',
  remove: 'remove',
};

export function updateFilterSchemaForCustomColumns(customColumnData, op) {
  const { entitySchema, odataOptions } = filterService;

  if (!entitySchema || !entitySchema.properties || !odataOptions || !odataOptions.fieldMap) {
    return;
  }

  const {
    id, name, columnFormat, expression,
  } = customColumnData;
  let { properties } = entitySchema;
  const { name: schemaName } = entitySchema;
  const { fieldMap } = odataOptions;
  const customColumnId = `CustomColumn${id}`;
  const performanceMetricsCustomColumnId = `PerformanceMetrics/${customColumnId}`;
  const popCustomColumnId = `PoP${customColumnId}`;
  const popCustomColumnChangeId = `PoP${customColumnId}Change`;
  const popCustomColumnChangePercentId = `PoP${customColumnId}ChangePercent`;
  const idList = [customColumnId, popCustomColumnId, popCustomColumnChangeId,
    popCustomColumnChangePercentId];

  if (op === customColumnOperations.add) {
    if (!properties[customColumnId]) {
      properties[customColumnId] = {
        filterable: true,
        format: columnFormat,
        id,
        isPercentValue: columnFormat === 'Percentage',
        name: performanceMetricsCustomColumnId,
        nullable: true,
        originalProperty: customColumnId,
        property: performanceMetricsCustomColumnId,
        required: true,
        title: name,
        type: 'number',
        isInvalidProperty: !isValidForFeature({
          schemaName,
          expression,
          permissions,
        }),
      };

      const tempEntitySchema = { properties: {} };
      tempEntitySchema.properties[customColumnId] = { ...properties[customColumnId] };
      appendPeriodOverPeriodProperties(tempEntitySchema);
      properties = _.defaults(properties, tempEntitySchema.properties);

      _.each(idList, (propertyId) => {
        fieldMap[propertyId] = properties[propertyId].property;
      });
    }
  } else if (op === customColumnOperations.edit) {
    let tempObject;

    if (properties[customColumnId]) {
      tempObject = properties[customColumnId];
      tempObject.title = name;
      tempObject.format = columnFormat;
      tempObject.isPercentValue = columnFormat === 'Percentage';
      tempObject.isInvalidProperty = !isValidForFeature({
        schemaName,
        expression,
        permissions,
      });
    }

    if (properties[popCustomColumnId]) {
      tempObject = properties[popCustomColumnId];
      tempObject.title = safeGetString('ColumnName_CustomColumn_Compare').replace('{0}', name);
      tempObject.format = columnFormat;
      tempObject.isPercentValue = columnFormat === 'Percentage';
    }

    if (properties[popCustomColumnChangeId]) {
      tempObject = properties[popCustomColumnChangeId];
      tempObject.title = safeGetString('ColumnName_CustomColumn_Change').replace('{0}', name);
      tempObject.format = columnFormat;
      tempObject.isPercentValue = columnFormat === 'Percentage';
    }

    if (properties[popCustomColumnChangePercentId]) {
      tempObject = properties[popCustomColumnChangePercentId];
      tempObject.title = safeGetString('ColumnName_CustomColumn_Change_Percentage').replace('{0}', name);
    }
  } else if (op === customColumnOperations.remove) {
    _.each(idList, (propertyId) => {
      if (properties[propertyId]) {
        delete properties[propertyId];
      }

      if (fieldMap[propertyId]) {
        delete fieldMap[propertyId];
      }
    });
  }
}

function removeAllQueriesInEditableFilter(editableFilter, columnId) {
  const changed = removeQueryByColumnId(editableFilter.query, columnId, true);

  if (changed) {
    const filterToSet = _.isEmpty(editableFilter.query) ? {} : editableFilter;

    filterService.setEditableFilter(filterToSet);
  }
}

function removeAllQueriesInSavedFilter(columnId) {
  filterService.getSavedFilters().then((savedFilters) => {
    _.each(savedFilters, (filter) => {
      const { query, name } = filter;
      const changed = removeQueryByColumnId(query, columnId, true);

      if (changed && _.isEmpty(query)) {
        filterService.deleteSavedFilter({
          name,
        }, FilterStorageType.EditableFilter);
        filterService.deleteSavedFilter({
          name,
        }, FilterStorageType.SelectableFilter);
        filterService.trigger('remove-saved-filter-name', name);
      } else if (changed) {
        const updateAppliedFilter = JSON.stringify(filterService.editableFilter.query)
          .indexOf(columnId) >= 0;

        filterService.addUpdateSavedFilter(
          query,
          name,
          FilterStorageType.EditableFilter,
          updateAppliedFilter
        );
      }
    });
  });
}

export function cleanUpCustomColumnFilter(columnId) {
  const editableFilter = filterService.getEditableFilter();

  if (editableFilter) {
    removeAllQueriesInEditableFilter(editableFilter, columnId);
  }

  removeAllQueriesInSavedFilter(columnId);
}
